import request from '../../request';
import { surveyTagServiceAPI } from './insightsUrls';

export class surveyTagService {
  static getTags() {
    return request({
      url: surveyTagServiceAPI.get,
      method: 'GET',
    })
      .then((response) => response)
      .catch((response) => response);
  }
  static putTag(tag) {
    return request({
      url: surveyTagServiceAPI.put,
      method: 'PUT',
      data: tag,
    })
      .then((response) => response)
      .catch((response) => response);
  }
  static postTag(tag) {
    return request({
      url: surveyTagServiceAPI.post,
      method: 'POST',
      data: tag,
    })
      .then((response) => response)
      .catch((response) => response);
  }
  static deleteTag(id) {
    return request({
      url: surveyTagServiceAPI.delete(id),
      method: 'DELETE',
    })
      .then((response) => response)
      .catch((response) => response);
  }
  // static mergeTag(data) {
  //   return request({
  //     url: tagServiceAPI.mergeTag,
  //     method: 'POST',
  //     data,
  //   })
  //     .then((response) => response)
  //     .catch((response) => response);
  // }
}

export default surveyTagService;
